import { Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import { useSelector } from 'react-redux';

let WholePortionAnnexAPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const lightweightAggregate: boolean = useSelector(
    createWorksheetSelector!('data.Preparation.LightweightAggregate', false)
  );

  return (
    <>
      <NamePrefixModifier appendNamePrefix="Masses.MassMeasurement">
        <ListFieldSection>
          <WorksheetBalanceFieldSet name="Equipment.Balance" />
          <Field input={<NumericInput />} name="BulkDensity" visible={lightweightAggregate} />
          <Field input={<NumericInput />} name="TareMass" />
          <Field input={<NumericInput />} name="TareAndWetMass" />
          <Field input={<TextOutput />} name="WetMass" />
          <Field input={<TextOutput />} name="Volume" visible={lightweightAggregate} />
        </ListFieldSection>
      </NamePrefixModifier>
    </>
  );
};

WholePortionAnnexAPreparationSection = withInjectedProps(WholePortionAnnexAPreparationSection);

export { WholePortionAnnexAPreparationSection };
export default WholePortionAnnexAPreparationSection;
